import { useConfigHelper, realmLocaleMapper } from '@ilteducation/config';

const codeToLanguageTag: Record<string, string> = {
  sv: 'sv-SE',
  gb: 'en-GB',
  us: 'en-US',
  de: 'de-DE',
  fi: 'fi-FI',
  fr: 'fr-FR',
  nb: 'nb-NO',
  nn: 'nn-NO',
  no: 'nb-NO',
  nl: 'nl-NL',
  dk: 'da-DK',
};

export const getRealmLanguage = (): string | undefined => {
  const { getOptionalRealm } = useConfigHelper();

  /*
   i18n setup is happening at import time, but realm is stored in preferences store in native apps, which is asynchronous.
   So realm might not be available when we setup 18n.
   */
  const realm = getOptionalRealm();
  if (!realm) {
    return undefined;
  }

  const lang = realmLocaleMapper[realm.toLowerCase()];

  if (!lang) {
    return undefined;
  }

  const languageTag = codeToLanguageTag[lang];

  if (languageTag) {
    return languageTag;
  }

  return lang;
};
